var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarsIa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63552 8.63552L7.02891 14.0578L5.4223 8.63552L0 7.02891L5.4223 5.4223L7.02891 0L8.63552 5.4223L14.0578 7.02891L8.63552 8.63552ZM15.062 13.2545L19.0785 11.0454L16.8694 15.062L19.0785 19.0785L15.062 16.8694L11.0454 19.0785L13.2545 15.062L11.0454 11.0454L15.062 13.2545ZM8.03304 15.062L6.32602 18.0743L8.03304 21.0867L5.02065 19.3797L2.00826 21.0867L3.71528 18.0743L2.00826 15.062L5.02065 16.769L8.03304 15.062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsIa);
export default __webpack_public_path__ + "static/media/StarsIA.ed0656d93a1c8c125f5d50088bd848ad.svg";
export { ForwardRef as ReactComponent };